var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "layout-switcher-trigger",
      attrs: { "data-component": "layout-switcher" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layout-switcher-trigger",
          attrs: { "data-button": "layout-switcher-trigger" },
          on: { click: _vm.onTogglePopup },
        },
        [
          _c(
            "label",
            { staticClass: "layout-switcher-trigger-label", style: _vm.style },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t(_vm.workspaces[_vm.activeWorkspace].name)) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("or-icon", {
            staticClass: "layout-switcher-trigger-icon",
            style: _vm.style,
            attrs: { icon: _vm.collapseIconType },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("or-teleport", [
        _vm.isOpen
          ? _c(
              "div",
              {
                style: { top: _vm.popupTop },
                attrs: { "data-popup": "layout-switcher-popup" },
              },
              [
                _c(
                  "div",
                  { staticClass: "layout-switcher-popup-content" },
                  [
                    _c("layout-switcher-menu", {
                      attrs: {
                        workspaces: _vm.workspaces,
                        "active-workspace": _vm.activeWorkspace,
                      },
                      on: {
                        "link-click": function ($event) {
                          return _vm.$emit("link-click", $event)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("layout-switcher-workspace", {
                      attrs: {
                        components: _vm.components,
                        workspace: _vm.workspaces[_vm.activeWorkspace],
                        "default-workspace":
                          _vm.defaultWorkspaces[_vm.activeWorkspace],
                      },
                      on: {
                        "layout-select": _vm.onLayoutSelect,
                        "layout-bookmark": function ($event) {
                          return _vm.$emit("layout-bookmark", $event)
                        },
                        "layout-reset": function ($event) {
                          return _vm.$emit("layout-reset", $event)
                        },
                        "layout-delete": function ($event) {
                          return _vm.$emit("layout-delete", $event)
                        },
                        "layout-create": function ($event) {
                          return _vm.$emit("layout-create", $event)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "layout-switcher-popup-overlay",
                  on: { click: _vm.onTogglePopup },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }